import React, { Component } from "react";
import { UncontrolledAlert, Button } from "reactstrap";
import { withFormsy } from "formsy-react";
import { MySelect } from "../../Shared/Forms";
import { Spinner } from "../../Shared";
import { merchantsService } from "./services/Merchants.service";

class MerchantDropdown extends Component {
  state = {
    fetching: false,
    fetched: false,
    response: null,
    error: null
  };

  componentDidMount() {
    this.getMerchants();
  }

  getMerchants = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await merchantsService.getAllMerchants(params);
      if (response) {
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          response: response.data,
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };

  render() {
    const {
      name,
      value,
      disabled,
      onChange,
      isMulti,
      title,
      isRequired,
      isClearable
    } = this.props;

    const { fetching, response, error } = this.state;

    return (
      <div>
        {fetching ? (
          <UncontrolledAlert color="info">
            <Spinner message="Fetching merchants" />
          </UncontrolledAlert>
        ) : (
          <div>
            <MySelect
              isMulti={isMulti}
              name={name}
              onChange={onChange}
              isClearable={isClearable}
              title={title}
              options={response ? response : []}
              value={value}
              valueKey="id"
              disabled={disabled}
              labelKey="name"
              innerRef={c => {
                this.metrics = c;
              }}
              required={isRequired}
            />
            {!response && error && (
              <UncontrolledAlert color="danger">
                {error.message}
                <div className="float-reight">
                  <Button color="danger" onClick={this.getMerchants}>
                    Retry
                  </Button>
                </div>
              </UncontrolledAlert>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withFormsy(MerchantDropdown);
